var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value)?_c('div',{staticClass:"qrcode-container",on:{"touchmove":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"qrcode-close",on:{"click":function($event){_vm.value = !_vm.value}}}),_c('img',{staticClass:"qrcode-img",attrs:{"src":_vm.followImg,"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }